import { axiosInstance } from "./axios";


export const GetParticipantSeansFeedbacklist = async(startDate, endDate, userId, page,search,deletedUsers) => {
  return await axiosInstance
    .get(`/participant/feedbacksByDate/${startDate}/${endDate}?userId=${userId}&page=${page}&search=${search}&showDeleted=${deletedUsers}`)
    .then(res =>  res.data.data)
    .catch((err) => console.log("e", err));
};
